
    <fieldmagic-primary-button
      icon="exclamation-circle"
      [label]="(details$ | async) | data_get: 'label'"
      [color]="(details$ | async) | data_get: 'color'"
      tooltip="Click to view defects"
      (click)="onView()"
      [disabled]="fetching$ | async"
    >
    </fieldmagic-primary-button>
  